import { useId } from 'react'
import cx from 'classnames'

export interface RadioOptionsProps {
  name: string
  options: RadioOptionProps[]
  value: string
  onChange: (value: string) => void
}

const RadioOptions = ({
  name,
  value,
  options,
  onChange,
}: RadioOptionsProps) => {
  const groupId = useId()

  return (
    <div className="radio-options">
      {options.map((option) => (
        <RadioOption
          key={option.value}
          {...option}
          groupId={groupId}
          name={name}
          active={value === option.value}
          onClick={() => onChange(option.value)}
        />
      ))}
    </div>
  )
}

export interface RadioOptionProps {
  groupId?: string
  name?: string
  image?: string
  label: string
  value: string
  active?: boolean
  onClick?: () => void
}

const RadioOption = ({
  groupId,
  name,
  image,
  label,
  value,
  active,
  onClick,
}: RadioOptionProps) => {
  const uniqueId = useId()
  const inputId = groupId ? `${groupId}-${value}` : `${uniqueId}-${value}`

  return (
    <div className={cx('radio-option', { 'is-active': active })}>
      {image ? (
        <img width={32} height={32} src={image} alt={label} />
      ) : (
        <div className="radio-option-placeholder" />
      )}
      <input
        className="sr-only"
        type="radio"
        id={inputId}
        name={name}
        checked={active}
        onChange={onClick}
      />
      <label className="radio-option-label" htmlFor={inputId}>
        {label}
      </label>
    </div>
  )
}

export default RadioOptions
